export enum Language {
  French = 'fr',
  English = 'en',
}
